<script setup>
import { computed, ref } from 'vue';
import ComboBox from 'dashboard/components-next/combobox/ComboBox.vue';
import Input from 'dashboard/components-next/input/Input.vue';
import { BANK_OPTIONS } from 'dashboard/routes/dashboard/settings/integrations/bankCatalog';

const props = defineProps({
  modelValue: { type: String, default: '' },
  label: { type: String, default: 'Banco / provedor' },
});
const emit = defineEmits(['update:modelValue']);
const manualOption = '__manual_provider__';
const manualLabel = 'Cadastrar banco manualmente';
const manualRequested = ref(
  !!props.modelValue &&
    !BANK_OPTIONS.some(bank => bank.value === props.modelValue)
);
const knownBank = computed(() =>
  BANK_OPTIONS.some(bank => bank.value === props.modelValue)
);
const isManual = computed(
  () => manualRequested.value || (!knownBank.value && !!props.modelValue)
);
const selection = computed(() =>
  isManual.value ? manualOption : props.modelValue
);
const options = [...BANK_OPTIONS, { value: manualOption, label: manualLabel }];
const selectProvider = value => {
  manualRequested.value = value === manualOption;
  emit('update:modelValue', manualRequested.value ? '' : value);
};
</script>

<template>
  <div class="flex flex-col gap-2">
    <div class="flex flex-col gap-1">
      <span class="mb-0.5 text-heading-3 text-n-slate-12">{{ label }}</span>
      <ComboBox
        :model-value="selection"
        :options="options"
        :aria-label="label"
        placeholder="Selecione um banco ou cadastre manualmente"
        search-placeholder="Buscar banco"
        empty-state="Nenhum banco encontrado. Use o cadastro manual abaixo."
        teleport-to-body
        @update:model-value="selectProvider"
      />
    </div>
    <Input
      v-if="isManual"
      :model-value="modelValue"
      label="Nome do banco / provedor"
      placeholder="Digite o nome do banco ou provedor"
      @update:model-value="emit('update:modelValue', $event)"
    />
    <button
      v-else
      type="button"
      class="self-start text-xs text-n-brand hover:underline"
      @click="selectProvider(manualOption)"
    >
      {{ manualLabel }}
    </button>
  </div>
</template>
